import React from 'react';
import { AuthProvider } from '../../context/AuthContext';
import { SplashPageV2 } from '../../SplashPageV2';
import ErrorBoundary from '../../components/ErrorBoundary';

export default function MainLayout() {
  return (
    <AuthProvider>
      <ErrorBoundary>
        {/* consider updating <SplashPageV2 /> to render a `child` and lifting <RootV2 /> here for clarity  */}
        <SplashPageV2 />
      </ErrorBoundary>
    </AuthProvider>
  );
}
